import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import BlockScr from "../components/block/Block_Scr";


function Coute() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Get-Coute">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="GET-COUTE"
          bgimg={`${rpdata?.gallery?.[9]}`}
        />
        <BlockScr/>
       

      </div>
    </BaseLayout>
  );
}

export default Coute;
